import {Box, Typography} from '@mui/material';
import './CodingFormHeader.scss';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {t} from 'i18next';
import {ReactComponent as InfoIcon} from '../../../../assets/images/info-icon.svg';
import ArrButton from '../../../common/arr-button/ArrButton';

const shortInfo = () => (
  <>
    <p data-testid={`coding-form-header-manage-coding-forms-info1`}>
      {t('codingForms.manage.manageCodingFormsInfo1')}
    </p>
    <p data-testid={`coding-form-header-manage-coding-forms-info2`}>
      {t('codingForms.manage.manageCodingFormsInfo2')}
    </p>
    <p
      data-testid={`coding-form-header-manage-coding-forms-info3-manage-coding-forms-info4`}
    >
      {t('codingForms.manage.manageCodingFormsInfo3')}
      <br data-testid={`coding-form-header-br`} />
      <a
        href="https://www.sightlinecentral.com/doc/sightline-documentation/coding-forms/"
        target="_blank"
        data-testid={`coding-form-header-manage-coding-forms-info4`}
      >
        {t('codingForms.manage.manageCodingFormsInfo4')}
      </a>
    </p>
  </>
);

const CodingFormHeader: React.FC<{
  onButtonClick: () => void;
  isButtonDisable: boolean;
  currentTab: number;
}> = ({onButtonClick, isButtonDisable = false, currentTab = 0}) => {
  return (
    <Box className="coding-form-header">
      <Box className="coding-form-title">
        <Typography
          className="typo-text headline3_size coding-form-title-text"
          data-testid={`coding-form-header-title`}
        >
          {currentTab == 0
            ? t('codingForms.manage.title')
            : t('codingForms.manage.createForm')}
        </Typography>
        <ArrTooltipWrapper
          title={t('codingForms.manage.infoTitle')}
          trigger={
            <InfoIcon
              fontSize="medium"
              className="coding-form-info-icon"
              data-testid="coding-form-info-icon"
            />
          }
        >
          {shortInfo()}
        </ArrTooltipWrapper>
      </Box>
      <Box>
        <ArrButton
          aria-label={t('codingForms.manage.newForm')}
          variant="primary"
          size="small"
          onClick={onButtonClick}
          className="new-coding-form-button"
          disabled={isButtonDisable}
          dataTestId="new-coding-form"
          id="new-coding-form"
          name="new-coding-form"
        >
          {t('codingForms.manage.newForm')}
        </ArrButton>
      </Box>
    </Box>
  );
};

export default CodingFormHeader;
